/**
 * Хранилище счётчиков непрочитанного для плашки и значков.
 *
 * notices.count   — непрочитанные уведомления (null, пока не загружено)
 * notices.latest  — последнее непрочитанное уведомление или null
 * messenger.count — диалоги мессенджера с непрочитанным (из окна мессенджера)
 */

const initialState = {
  notices: { count: null, latest: null },
  messenger: { count: 0 },
};

let state = initialState;
const listeners = new Set();

export const getUnreadState = () => state;

export const subscribeUnread = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const emit = () => listeners.forEach((listener) => listener());

export const setNotices = ({ count, latest = null }) => {
  const nextCount = Number.isFinite(count) ? count : 0;
  const nextLatest = nextCount > 0 ? latest : null;
  if (
    state.notices.count === nextCount &&
    state.notices.latest?.uuid === nextLatest?.uuid &&
    state.notices.latest?.title === nextLatest?.title
  ) {
    return;
  }
  state = { ...state, notices: { count: nextCount, latest: nextLatest } };
  emit();
};

export const setMessengerCount = (count) => {
  const nextCount = Number.isFinite(count) && count > 0 ? count : 0;
  if (state.messenger.count === nextCount) {
    return;
  }
  state = { ...state, messenger: { count: nextCount } };
  emit();
};

// Для тестов.
export const resetUnreadState = () => {
  state = initialState;
  emit();
};
